export const getFileInputType = (fileInfo) => {
    let inputType;
    try{
        inputType = fileInfo['inputType']
    } catch (e) { inputType = null}

    return inputType
}